import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { toastError } from "@/lib/toast";
import { isSuppressedToast } from "@/lib/api/error-display";

/** Shared TanStack Query client. Auth errors are suppressed (handled by the auth hook). */
export const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error) => {
			if (isSuppressedToast(error)) return;
			toastError(error);
		},
	}),
	mutationCache: new MutationCache({
		onError: (error) => {
			if (isSuppressedToast(error)) return;
			toastError(error);
		},
	}),
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			refetchOnWindowFocus: false,
			retry: (failureCount, error) => {
				// Never retry client errors (4xx) or auth failures; allow a couple of
				// attempts for transient network/5xx issues.
				if (error instanceof Error && "status" in error) {
					const status = (error as { status: number }).status;
					if (status >= 400 && status < 500) return false;
				}
				return failureCount < 2;
			},
		},
		mutations: {
			retry: false,
		},
	},
});
